module.exports = __webpack_public_path__ + "img/引导弹窗@3x.fe18d6a8.png";